export const selfQuestionnaires = [




  {
    'no': 0,
    'title': '외인성 화합물질 내성 검사 XTT',
    'desc': '외인성 화합물질 내성 검사 XTT, Xenobiotic Tolerability Test',
    'questions': [
      {
        'askNo': 0,
        'askType': 'single',
        'ask': '당신은 병원에서 처방 받은 약물을 복용중입니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '아니오', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '네. 그렇다면 얼마나 많은 약물을 복용중 입니까?', 'answerPoint': 1 }
        ]
      },
      {
        'askNo': 1,
        'askType': 'multiple',
        'ask': '다음 약물을 복용중입니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '시메티딘(cimetidine)', 'answerPoint': 2 },
          { 'answerNo': 1, 'answerTitle': '타이레놀', 'answerPoint': 2 },
          { 'answerNo': 2, 'answerTitle': '여성호르몬제', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '아니오', 'answerPoint': 0 }
        ]
      },
      {
        'askNo': 2,
        'askType': 'single',
        'ask': '이전에 병원에서 처방 받은 약물을 복용했던 경험이 있다면, 약을 복용한 다음 어떤 반응이 가장 많았습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '부작용을 경험했으며, 낮은 용량에서도 효과가 있었다', 'answerPoint': 3 },
          { 'answerNo': 1, 'answerTitle': '부작용을 경험했으며, 일반적인 용량에서도 효과가 있었다', 'answerPoint': 2 },
          { 'answerNo': 2, 'answerTitle': '부작용이 없었으며, 대개 약물의 효과도 없었다', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '부작용이 없었으며, 대개 약물도 효과가 있었다', 'answerPoint': 0 }
        ]
      },
      {
        'askNo': 3,
        'askType': 'single',
        'ask': '최근 6개월동안 지속적으로 흡연을 해왔습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '네', 'answerPoint': 2 },
          { 'answerNo': 1, 'answerTitle': '아니오', 'answerPoint': 0 }
        ]
      },
      {
        'askNo': 4,
        'askType': 'single',
        'ask': '카페인 또는 카페인을 포함한 물질(게보린, 펜잘, 초콜렛, 커피 등)에 대해 심각한 부작용을 경험한 적이 있습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '네', 'answerPoint': 2 },
          { 'answerNo': 1, 'answerTitle': '아니오', 'answerPoint': 0 },
          { 'answerNo': 2, 'answerTitle': '모르겠음', 'answerPoint': 0 }
        ]
      },
      {
        'askNo': 5,
        'askType': 'single',
        'ask': '집중이 잘 안되고 혼란스러우며 집중이 잘 안 되는 상황, 피로, 나른함을 자주 경험합니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '네', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니오', 'answerPoint': 0 }
        ]
      },
      {
        'askNo': 6,
        'askType': 'single',
        'ask': '향수나 진한 향을 맡을 때 발생하는 증상이 있습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '네', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니오', 'answerPoint': 0 },
          { 'answerNo': 2, 'answerTitle': '모르겠음', 'answerPoint': 0 }
        ]
      },
      {
        'askNo': 7,
        'askType': 'single',
        'ask': '술을 조금만 마셔도 어려움을 느낍니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '네', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니오', 'answerPoint': 0 }
        ]
      },
      {
        'askNo': 8,
        'askType': 'multiple',
        'ask': '다음의 병력이 있습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '환경 및 화학물질에 대한 과민반응', 'answerPoint': 5 },
          { 'answerNo': 1, 'answerTitle': '만성피로증후군', 'answerPoint': 5 },
          { 'answerNo': 2, 'answerTitle': '섬유근육통', 'answerPoint': 3 },
          { 'answerNo': 3, 'answerTitle': '파킨슨 증후군 증상', 'answerPoint': 3 },
          { 'answerNo': 4, 'answerTitle': '알코올 또는 화학물질에 대한 의존', 'answerPoint': 2 },
          { 'answerNo': 5, 'answerTitle': '천식', 'answerPoint': 1 },
          { 'answerNo': 6, 'answerTitle': '없음', 'answerPoint': 0 }
        ]
      },
      {
        'askNo': 9,
        'askType': 'single',
        'ask': '제초제, 살충제, 유기용매 등과 같은 유해한 화학물질에 노출된 경험이 있습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '네', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니오', 'answerPoint': 0 }
        ]
      },
      {
        'askNo': 10,
        'askType': 'single',
        'ask': '와인, 건과일, 샐러드바, 야채 등과 같이 아황산염(sulfite)을 포함한 음식을 먹었을 때 알레르기 반응이나 부작용을 경험한 적이 있습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '네', 'answerPoint': 2 },
          { 'answerNo': 1, 'answerTitle': '아니오', 'answerPoint': 0 },
          { 'answerNo': 2, 'answerTitle': '모르겠음', 'answerPoint': 0 }
        ]
      }
    ],
    'intervention': [
      'With Low ALP; Zn 보충', 'High XTT; TMA c OAA', '3~6Mo. 후 F/U', 'GSH, MegaC, kyominotin, weekly x 8'
    ],
    'resultType': 'gauge',
    'resultTitle': '',
    'results': [
      { 'resultNo': 0, 'resultCondition': '4점 미만', 'resultTitle': '정상', 'resultIconType': 'MoodIcon' },
      { 'resultNo': 1, 'resultCondition': '5~9점', 'resultTitle': '주의요망', 'resultIconType': 'SentimentNeutralIcon' },
      { 'resultNo': 2, 'resultCondition': '10점 이상', 'resultTitle': '외인성 약물 중독 높음', 'resultIconType': 'MoodBadIcon' },
    ],
    'resultMaxPoint': 39,
    'subArcs' : [ { limit: 4 }, { limit: 9 }, { limit: 39 } ],
    'colorArray' : [ '#47D9D9', '#FFBB00', '#C80000' ]
  },
  
  
  
  
  
  {
    'no': 1,
    'title': 'Cohen Perceived Stress',
    'desc': '이 검사의 질문들은 지난 한 달 동안 당신이 어떤 일에 대해서 얼마나 자주 그렇게 느꼈는지, 어떤 생각을 했는지에 대해 묻는 스트레스 검사입니다. 어떤 문항들은 비슷해 보이지만 각 문항마다 작은 차이점이 존재하기 때문에 각각의 문제를 독립된 문제로 인지하고 대답해야 합니다. 가장 정확한 결과를 얻기 위해서 질문을 읽고 바로바로 대답을 해주십시오.',
    'questions': [
      {
        'askNo': 0,
        'askType': 'single',
        'ask': '1. 지난 한 달 동안, 예상치 못한 일이 생겨서 기분 나빠진 적이 얼마나 자주 있었나요?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '절대 아님', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '거의 아님', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '가끔', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '대체로 그러함', 'answerPoint': 3 },
          { 'answerNo': 4, 'answerTitle': '자주 그러함', 'answerPoint': 4 }
        ]
      },
      {
        'askNo': 1,
        'askType': 'single',
        'ask': '2. 지난 한 달 동안, 중요한 일들을 통제할 수 없다고 느낀 적이 얼마나 자주 있었나요?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '절대 아님', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '거의 아님', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '가끔', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '대체로 그러함', 'answerPoint': 3 },
          { 'answerNo': 4, 'answerTitle': '자주 그러함', 'answerPoint': 4 }
        ]
      },
      {
        'askNo': 2,
        'askType': 'single',
        'ask': '3. 지난 한 달 동안, 초조하거나 스트레스가 쌓인다고 느낀 적이 얼마나 자주 있었나요?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '절대 아님', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '거의 아님', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '가끔', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '대체로 그러함', 'answerPoint': 3 },
          { 'answerNo': 4, 'answerTitle': '자주 그러함', 'answerPoint': 4 }
        ]
      },
      {
        'askNo': 3,
        'askType': 'single',
        'ask': '4. 지난 한 달 동안, 짜증나고 성가신 일들을 성공적으로 처리한 적이 얼마나 자주 있었나요?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '절대 아님', 'answerPoint': 4 },
          { 'answerNo': 1, 'answerTitle': '거의 아님', 'answerPoint': 3 },
          { 'answerNo': 2, 'answerTitle': '가끔', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '대체로 그러함', 'answerPoint': 1 },
          { 'answerNo': 4, 'answerTitle': '자주 그러함', 'answerPoint': 0 }
        ]
      },
      {
        'askNo': 4,
        'askType': 'single',
        'ask': '5. 지난 한 달 동안, 생활 속에서 일어난 중요한 변화들을 효과적으로 대처한 적이 얼마나 자주 있었나요?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '절대 아님', 'answerPoint': 4 },
          { 'answerNo': 1, 'answerTitle': '거의 아님', 'answerPoint': 3 },
          { 'answerNo': 2, 'answerTitle': '가끔', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '대체로 그러함', 'answerPoint': 1 },
          { 'answerNo': 4, 'answerTitle': '자주 그러함', 'answerPoint': 0 }
        ]
      },
      {
        'askNo': 5,
        'askType': 'single',
        'ask': '6. 지난 한 달 동안, 자신에게 중요한 일을 잘 대처하지 못했다고 얼마나 자주 느꼈나요?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '절대 아님', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '거의 아님', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '가끔', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '대체로 그러함', 'answerPoint': 3 },
          { 'answerNo': 4, 'answerTitle': '자주 그러함', 'answerPoint': 4 }
        ]
      },
      {
        'askNo': 6,
        'askType': 'single',
        'ask': '7. 지난 한 달 동안, 자신의 뜻대로 일이 진행된다고 느낀 적이 얼마나 자주 있었나요?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '절대 아님', 'answerPoint': 4 },
          { 'answerNo': 1, 'answerTitle': '거의 아님', 'answerPoint': 3 },
          { 'answerNo': 2, 'answerTitle': '가끔', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '대체로 그러함', 'answerPoint': 1 },
          { 'answerNo': 4, 'answerTitle': '자주 그러함', 'answerPoint': 0 }
        ]
      },
      {
        'askNo': 7,
        'askType': 'single',
        'ask': '8. 지난 한 달 동안, 매사를 잘 컨트롤하고 있다고 느낀 적이 얼마나 자주 있었나요?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '절대 아님', 'answerPoint': 4 },
          { 'answerNo': 1, 'answerTitle': '거의 아님', 'answerPoint': 3 },
          { 'answerNo': 2, 'answerTitle': '가끔', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '대체로 그러함', 'answerPoint': 1 },
          { 'answerNo': 4, 'answerTitle': '자주 그러함', 'answerPoint': 0 }
        ]
      },
      {
        'askNo': 8,
        'askType': 'single',
        'ask': '9. 지난 한 달 동안, 당신이 통제할 수 없는 범위에서 발생한 일 때문에 화가난 적이 얼마나 자주 있었나요?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '절대 아님', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '거의 아님', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '가끔', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '대체로 그러함', 'answerPoint': 3 },
          { 'answerNo': 4, 'answerTitle': '자주 그러함', 'answerPoint': 4 }
        ]
      },
      {
        'askNo': 9,
        'askType': 'single',
        'ask': '10. 지난 한 달 동안, 어려운 일이 너무 많이 쌓여서 극복할 수 없다고 느낀적이 얼마나 자주 있었나요?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '절대 아님', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '거의 아님', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '가끔', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '대체로 그러함', 'answerPoint': 3 },
          { 'answerNo': 4, 'answerTitle': '자주 그러함', 'answerPoint': 4 }
        ]
      }
    ],
    'intervention': [
      '20점 이상이면 스트레스가 높은 것으로 간주되며, 이 범위에 속한다면 새로운 스트레스 감소 기술을 배우고 운동량을 일주일에 3회 이상으로 늘리는 것이 좋습니다.','높은 심리적 스트레스는 고혈압, BMI 증가, 허리-엉덩이 비율 증가, 텔로미어 길이 감소, 코티솔 수치 증가, 면역 기능 억제, 수면 감소, 음주 증가와 관련이 있습니다. 이것들은 모두 심혈관 질환의 중요한 위험 요소입니다.'
    ],
    'resultType': 'gauge',
    'resultTitle': '',
    'results': [
      { 'resultNo': 0, 'resultCondition': '총점 13점 미만', 'resultTitle': '양호', 'resultIconType': 'MoodIcon' },
      { 'resultNo': 1, 'resultCondition': '총점 13~20점 미만', 'resultTitle': '평균', 'resultIconType': 'SentimentNeutralIcon' },
      { 'resultNo': 2, 'resultCondition': '총점 20점 이상', 'resultTitle': '높은 스트레스 그룹', 'resultIconType': 'MoodBadIcon' },
    ],
    'resultMaxPoint': 40,
    'subArcs' : [ { limit: 13 }, { limit: 20 }, { limit: 40 } ],
    'colorArray' : [ '#47D9D9', '#FFBB00', '#C80000' ]
  },
  
  
  
  
  
  { 
    'no': 2,
    'title': '과민성 방광 증상 자가 진단',
    'desc': '최근 1주일간 당신의 상태에 가장 가까운 것을 하나만 골라 답해주세요.',
    'questions': [
      {
        'askNo': 0,
        'askType': 'single',
        'ask': '1. 아침에 일어나서 밤에 자기 전까지 몇 회 정도 소변을 보셨습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '7회 이하', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '8~14회', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '15회 이상', 'answerPoint': 2 }
        ]
      },
      {
        'askNo': 1,
        'askType': 'single',
        'ask': '2. 밤에 잠든 후부터 아침에 일어날 때까지 소변을 보기 위해 몇 회나 일어나셨습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '0회', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '1회', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '2회', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '3회 이상', 'answerPoint': 3 }
        ]
      },
      {
        'askNo': 2,
        'askType': 'single',
        'ask': '3. 갑자기 소변이 마려워 참기 힘들었던 적이 있었습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '없음', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '일주일에 1회보다는 적음', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '일주일에 1회 혹은 그 이상', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '일 1회 정도', 'answerPoint': 3 },
          { 'answerNo': 3, 'answerTitle': '일 1회 2~4회 정도', 'answerPoint': 4 },
          { 'answerNo': 3, 'answerTitle': '일 1회 5회 또는 그 이상', 'answerPoint': 5 }
        ]
      },
      {
        'askNo': 3,
        'askType': 'single',
        'ask': '4. 갑자기 소변이 마려워서 참지 못하고 소변을 지린 적이 있었습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '없음', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '일주일에 1회보다는 적음', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '일주일에 1회 혹은 그 이상', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '일 1회 정도', 'answerPoint': 3 },
          { 'answerNo': 3, 'answerTitle': '일 1회 2~4회 정도', 'answerPoint': 4 },
          { 'answerNo': 3, 'answerTitle': '일 1회 5회 또는 그 이상', 'answerPoint': 5 }
        ]
      }
    ],
    'intervention': [
    ],
    'resultType': 'gauge',
    'resultTitle': '',
    'results': [
      { 'resultNo': 0, 'resultCondition': '총점 2점 이하', 'resultTitle': '양호', 'resultIconType': 'MoodIcon' },
      { 'resultNo': 1, 'resultCondition': '총점 3점 이상', 'resultTitle': '상담', 'resultIconType': 'SentimentSatisfiedAltIcon' },
      { 'resultNo': 2, 'resultCondition': '총점 5점 이하', 'resultTitle': '경증', 'resultIconType': 'SentimentNeutralIcon' },
      { 'resultNo': 3, 'resultCondition': '총점 6~11점 이상', 'resultTitle': '중증도', 'resultIconType': 'SentimentVeryDissatisfiedIcon' },
      { 'resultNo': 4, 'resultCondition': '총점 12점 이상', 'resultTitle': '중증', 'resultIconType': 'MoodBadIcon' },
    ],
    'resultMaxPoint': 15,
    'subArcs' : [ { limit: 2 }, { limit: 4 }, { limit: 5 }, { limit: 11 }, { limit: 15 } ],
    'colorArray' : [ '#47D9D9', '#8AB904', '#FFBB00', '#FF8000', '#C80000' ]
  },
  
  
  
  
  
  {
    'no': 3,
    'title': '탈모 자가 진단',
    'desc': '',
    'questions': [
      {
        'askNo': 0,
        'askType': 'single',
        'ask': '1. 평소 어깨 결림이 자주 발생한다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 1,
        'askType': 'single',
        'ask': '2. 수족이 차가운 편이다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 2,
        'askType': 'single',
        'ask': '3. 간 기능에 이상이 있거나 약을 복용한 적이 있다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 3,
        'askType': 'single',
        'ask': '4. 식사를 자주 거른다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 4,
        'askType': 'single',
        'ask': '5. 체중의 변화가 급속도로 증가하거나 빠졌다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 5,
        'askType': 'single',
        'ask': '6. 음주를 즐긴다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 6,
        'askType': 'single',
        'ask': '7. 병으로 인해 같은 약을 오랜 시간 복용한 적이 있다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 7,
        'askType': 'single',
        'ask': '8. 스트레스를 많이 받는 편이다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 8,
        'askType': 'single',
        'ask': '9. 땀을 많이 흘리는 과격한 운동을 좋아한다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 9,
        'askType': 'single',
        'ask': '10. 머리를 매일 감지 않는다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 10,
        'askType': 'single',
        'ask': '11. 머리를 감을 때 비누를 사용한다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 11,
        'askType': 'single',
        'ask': '12. 모자를 자주 쓴다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 12,
        'askType': 'single',
        'ask': '13. 헤어 스타일을 자주 바꾼다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 13,
        'askType': 'single',
        'ask': '14. 드라이어를 매일 10분 이상 사용한다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 14,
        'askType': 'single',
        'ask': '15. 비듬이 자주 생기거나 가렵다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      }
    ],
    'intervention': [
      '[머리감기] 탈모 예방을 위해 가장 중요한 것이 두피의 청결입니다. 머리를 자주 감으면 탈모가 된다고 생각하는 사람들이 많으나 머리를 감을 때 빠지는 정도는 정상적인 것입니다. 오히려 머리를 감지 않아 두피에 피지와 같은 노폐물이 쌓이게 되면 지루성 피부염이나 모낭염 등을 일으켜 탈모의 원인이 될 수 있으므로, 지루 피부염이 있는 경우에는 하루 2번 머리를 감도록 합니다.', 
      '[비듬관리] 비듬이 있는 두피는 비듬 전용샴푸를 사용해야 합니다. 지성두피의 경우 세정력이 강한 지성용 샴푸를 사용하고 린스나 컨디셔너는 사용하지 않는 것이 좋습니다. 반면 건성의 경우 세정력이 약한 중성용 샴푸를 사용하고 린스나 컨디셔너를 사용하는 것이 좋습니다.', 
      '[두피관리] 지성두피의 경우 한 부분 또는 전반에 걸쳐 여드름 또는 뾰루지 같은 것이 나타나게 되는데 이를 만지거나 긁으면 두피가 붓거나 통증이 유발되는 경우가 많으며, 이로 인해 탈모가 심해질 수 있습니다. 머리를 감을 때는 모발 뿐 아니라 두피까지 잘 씻어 주고, 긁지 말고 피부과 전문의의 진찰을 받도록 합니다.'
    ],
    'resultType': 'simple',
    'resultTitle': '문항 중 5개 이상에 해당이 되면 탈모가 발생할 가능성이 높기 때문에 미리 관리를 해 주어야 합니다.',
    'results': [],
    'resultMaxPoint': 0,
    'subArcs' : [],
    'colorArray' : []
  },
  
  
  
  
  {
    'no': 4,
    'title': '돌연사 위험 자가 진단',
    'desc': '',
    'questions': [
      {
        'askNo': 0,
        'askType': 'single',
        'ask': '늘 나른하고, 조금 전에 들은 이야기도 잊을 때가 많다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 1,
        'askType': 'single',
        'ask': '갑자기 술이 약해지고, 마셔도 전처럼 기분이 좋아지지 않고 맛도 없다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 2,
        'askType': 'single',
        'ask': '"늙었다" 라는 말을 자주 듣고, 스스로도 몸이 예전 같지 않다고 느낀다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 3,
        'askType': 'single',
        'ask': '어깨나 목덜미가 뻣뻣하다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 4,
        'askType': 'single',
        'ask': '근심, 걱정으로 잠을 설칠 때가 많다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 5,
        'askType': 'single',
        'ask': '작은 일에도 초조해 하고, 화를 많이 낸다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 6,
        'askType': 'single',
        'ask': '가끔 심한 두통이 있고, 가슴이 답답하고 조이는 것 같은 느낌이 있다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 7,
        'askType': 'single',
        'ask': '최근 건강검진에서 고혈압, 당뇨병, 심전도 이상 등의 위험이 발견되었다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 8,
        'askType': 'single',
        'ask': '최근 갑자기 체중이 늘었다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 9,
        'askType': 'single',
        'ask': '몇 개월 동안 거의 매일 저녁에 업무와 관련된 술을 마셨다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 10,
        'askType': 'single',
        'ask': '하루에 다섯 잔 이상의 커피를 마신다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 11,
        'askType': 'single',
        'ask': '식사 시간이나 횟수가 일정하지 않고, 아침을 자주 거른다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 12,
        'askType': 'single',
        'ask': '튀김, 돼지고기 등의 기름진 음식을 좋아하고 자주 먹는다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 13,
        'askType': 'single',
        'ask': '담배를 하루 30개비 이상 피운다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 14,
        'askType': 'single',
        'ask': '밤 10시 전에 귀가하는 일이 거의 없고, 일주일에 절반은 밤 12시 이후에 귀가한다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 15,
        'askType': 'single',
        'ask': '출퇴근 거리가 2시간 이상 걸린다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 16,
        'askType': 'single',
        'ask': '최근 몇 년동안 운동을 해서 땀을 흘린 일이 거의 없다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 17,
        'askType': 'single',
        'ask': '최근 1~2년 사이에 건강검진을 받은 일이 한 번도 없다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 18,
        'askType': 'single',
        'ask': '하루 10시간 이상 일을 하는 경우가 많다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 19,
        'askType': 'single',
        'ask': '대부분의 휴일을 회사에서 일을 하면서 보낸다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 20,
        'askType': 'single',
        'ask': '출장이 잦고 집에 돌아와 자는 것은 주 2~3회 뿐이다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 21,
        'askType': 'single',
        'ask': '야근이 많고 근무시간이 불규칙하다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 22,
        'askType': 'single',
        'ask': '전직이나 인사이동으로 직장 근무환경 또는 업무내용이 달라졌다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 23,
        'askType': 'single',
        'ask': '승진으로 책임이 예전보다 무거워졌다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 24,
        'askType': 'single',
        'ask': '기한 내에 마쳐야 할 작업이 많아지고 업무량이 늘었다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 25,
        'askType': 'single',
        'ask': '최근 직장 내 인간관계가 나빠졌다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 26,
        'askType': 'single',
        'ask': '최근 업무상 커다란 실수를 저질렀다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      }
    ],
    'intervention': [
    ],
    'resultType': 'gauge',
    'resultTitle': '',
    'results': [
      { 'resultNo': 0, 'resultCondition': '6개 이하', 'resultTitle': '양호', 'resultIconType': 'MoodIcon' },
      { 'resultNo': 1, 'resultCondition': '7~9개', 'resultTitle': '돌연사 예비군', 'resultIconType': 'SentimentNeutralIcon' },
      { 'resultNo': 2, 'resultCondition': '10개 이상', 'resultTitle': '돌연사 고 위험군', 'resultIconType': 'MoodBadIcon' },
    ],
    'resultMaxPoint': 27,
    'subArcs' : [ { limit: 6 }, { limit: 9 }, { limit: 27 } ],
    'colorArray' : [ '#47D9D9', '#FFBB00', '#C80000' ]
  },
  
  
  
  
  {
    'no': 5,
    'title': 'ADHA 자가 진단',
    'desc': '',
    'questions': [
      {
        'askNo': 0,
        'askType': 'single',
        'ask': '차분하지 못하고 너무 활동적이다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '전혀 아니다', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '약간 그렇다', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '자주 그렇다', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '매우 그렇다', 'answerPoint': 3 }
        ]
      },
      {
        'askNo': 1,
        'askType': 'single',
        'ask': '쉽게 흥분하고 충동적으로 행동한다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '전혀 아니다', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '약간 그렇다', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '자주 그렇다', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '매우 그렇다', 'answerPoint': 3 }
        ]
      },
      {
        'askNo': 2,
        'askType': 'single',
        'ask': '다른 아이들에게 방해가 된다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '전혀 아니다', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '약간 그렇다', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '자주 그렇다', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '매우 그렇다', 'answerPoint': 3 }
        ]
      },
      {
        'askNo': 3,
        'askType': 'single',
        'ask': '한 번 시작한 일을 끝마치지 못한다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '전혀 아니다', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '약간 그렇다', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '자주 그렇다', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '매우 그렇다', 'answerPoint': 3 }
        ]
      },
      {
        'askNo': 4,
        'askType': 'single',
        'ask': '가만히 있지 못하고 계속 움직이는 등 안절부절한다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '전혀 아니다', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '약간 그렇다', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '자주 그렇다', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '매우 그렇다', 'answerPoint': 3 }
        ]
      },
      {
        'askNo': 5,
        'askType': 'single',
        'ask': '주의력이 없고, 외부자극에 쉽게 산만해진다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '전혀 아니다', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '약간 그렇다', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '자주 그렇다', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '매우 그렇다', 'answerPoint': 3 }
        ]
      },
      {
        'askNo': 6,
        'askType': 'single',
        'ask': '요구하는 것이 있으면 금방 들어주어야 한다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '전혀 아니다', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '약간 그렇다', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '자주 그렇다', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '매우 그렇다', 'answerPoint': 3 }
        ]
      },
      {
        'askNo': 7,
        'askType': 'single',
        'ask': '자주 또 쉽게 울어 버린다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '전혀 아니다', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '약간 그렇다', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '자주 그렇다', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '매우 그렇다', 'answerPoint': 3 }
        ]
      },
      {
        'askNo': 8,
        'askType': 'single',
        'ask': '금방 기분이 확 변한다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '전혀 아니다', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '약간 그렇다', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '자주 그렇다', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '매우 그렇다', 'answerPoint': 3 }
        ]
      },
      {
        'askNo': 9,
        'askType': 'single',
        'ask': '감정이 격하기 쉽고 행동을 예측하기 어렵다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '전혀 아니다', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '약간 그렇다', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '자주 그렇다', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '매우 그렇다', 'answerPoint': 3 }
        ]
      }
    ],
    'intervention': [
    ],
    'resultType': 'gauge',
    'resultTitle': '',
    'results': [
      { 'resultNo': 0, 'resultCondition': '총점 0~15점', 'resultTitle': '평범한 아이들의 행동수준을 가지고 있습니다. 아이들은 발달시기에 따라 정상적으로 부주의, 산만함 등이 나타날 수 있다. 부모가 아이에게 무리한 기준을 정해서 달성하도록 강요하거나 양육자가 수시로 바뀌는 등의 환경은 산만한 아이를 만들 수 있으므로 주의가 필요하다.', 'resultIconType': 'MoodIcon' },
      { 'resultNo': 1, 'resultCondition': '총점 16점 이상', 'resultTitle': '주의력결핍 과잉행동장애(ADHD)가 의심된다. ADHD는 소아 정신과 전문의의 진찰과 심리검사를 통해서만 진단이 가능하므로, 섣부른 판단을 하기 보다는 반드시 병원방문을 통하여 확인한다.', 'resultIconType': 'MoodBadIcon' },
    ],
    'resultMaxPoint': 30,
    'subArcs' : [ { limit: 15 }, { limit: 30 } ],
    'colorArray' : [ '#47D9D9', '#C80000' ]
  },
  
  
  
  
  {
    'no': 6,
    'title': '심장병 자가 진단',
    'desc': '',
    'questions': [
      {
        'askNo': 0,
        'askType': 'single',
        'ask': '가슴이 꽉 조여지는 듯한 느낌이 자주 든다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 1,
        'askType': 'single',
        'ask': '스트레스를 자주 받는다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 2,
        'askType': 'single',
        'ask': '화를 잘 내고 신경질적이라는 소리를 종종 듣는다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 3,
        'askType': 'single',
        'ask': '빨리 걸으면 숨이 차서 서있기가 힘들다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 4,
        'askType': 'single',
        'ask': '불안해서 깊은 잠을 이루지 못한다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 5,
        'askType': 'single',
        'ask': '한밤중에도 화장실에 가는 일이 잦다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 6,
        'askType': 'single',
        'ask': '가슴이 자주 두근거린다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 7,
        'askType': 'single',
        'ask': '숨을 얕게 쉬고 건망증이 심한 편이다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 8,
        'askType': 'single',
        'ask': '머리가 깨질 것 같은 두통이 반복된다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 9,
        'askType': 'single',
        'ask': '혈압이 일정하지 않다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 10,
        'askType': 'single',
        'ask': '표준에 비해 몸무게가 많이 나간다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 11,
        'askType': 'single',
        'ask': '답답해서 겨울에도 옷을 얇게 입는 편이다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 12,
        'askType': 'single',
        'ask': '맥박이 빠르거나 느린 편이다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      }
    ],
    'intervention': [
    ],
    'resultType': 'gauge',
    'resultTitle': '',
    'results': [
      { 'resultNo': 0, 'resultCondition': '3개 이하', 'resultTitle': '건강', 'resultIconType': 'MoodIcon' },
      { 'resultNo': 1, 'resultCondition': '4~9개', 'resultTitle': '동맥경화, 고지혈증 등이 진행될 수 있다.', 'resultIconType': 'SentimentNeutralIcon' },
      { 'resultNo': 2, 'resultCondition': '10개 이상', 'resultTitle': '심장 질환 고위험군', 'resultIconType': 'MoodBadIcon' },
    ],
    'resultMaxPoint': 13,
    'subArcs' : [ { limit: 3 }, { limit: 9 }, { limit: 13 } ],
    'colorArray' : [ '#47D9D9', '#FFBB00', '#C80000' ]
  },
  
  
  
  
  {
    'no': 7,
    'title': '당뇨병 가능성 자가 진단',
    'desc': '',
    'questions': [
      {
        'askNo': 0,
        'askType': 'single',
        'ask': '가족 중에 당뇨병인 사람이 있다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 1,
        'askType': 'single',
        'ask': '운동 부족으로 비만상태이다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 2,
        'askType': 'single',
        'ask': '스트레스가 많다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 3,
        'askType': 'single',
        'ask': '뚱뚱한 체형이었는데 갑자기 말랐다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 4,
        'askType': 'single',
        'ask': ' 목이 자주 말라 물을 많이 마신다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 5,
        'askType': 'single',
        'ask': '소변을 자주 보고 양도 많다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 6,
        'askType': 'single',
        'ask': '식욕이 좋아져 밥을 많이 먹는다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 7,
        'askType': 'single',
        'ask': '나른하고 자주 피로하다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 8,
        'askType': 'single',
        'ask': '신경통이 있거나 몸의 어느 부위가 짜릿하거나 근질근질한 증상이 있다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 9,
        'askType': 'single',
        'ask': '아무것도 나지 않았는데 피부가 가렵다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 10,
        'askType': 'single',
        'ask': '부스럼이 잘 생긴다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 11,
        'askType': 'single',
        'ask': '성기능이 감퇴되었다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 12,
        'askType': 'single',
        'ask': '소변에 당이 나온다고 들은 적이 있다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 13,
        'askType': 'single',
        'ask': '혈액검사상 혈당치가 높다. (또는 검사를 해본 일이 없다.)',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      }
    ],
    'intervention': [
    ],
    'resultType': 'gauge',
    'resultTitle': '',
    'results': [
      { 'resultNo': 0, 'resultCondition': '4개 이하', 'resultTitle': '정상', 'resultIconType': 'MoodIcon' },
      { 'resultNo': 1, 'resultCondition': '5~9개', 'resultTitle': '당뇨병 가능성이 있는 상태', 'resultIconType': 'SentimentNeutralIcon' },
      { 'resultNo': 2, 'resultCondition': '10~12개', 'resultTitle': '당뇨병의 가능성이 아주 높은 상태, 내과를 방문해서 진료 및 검사 권장', 'resultIconType': 'SentimentVeryDissatisfiedIcon' },
      { 'resultNo': 3, 'resultCondition': '13개 이상', 'resultTitle': '확실한 당뇨병 상태 일 것으로 생각. 반드시 내과를 방문하여 진료 및 검사를 받고 치료를 시작하기 권장', 'resultIconType': 'MoodBadIcon' },
    ],
    'resultMaxPoint': 14,
    'subArcs' : [ { limit: 4 }, { limit: 9 }, { limit: 12 }, { limit: 14 } ],
    'colorArray' : [ '#47D9D9', '#FFBB00', '#FF8000', '#C80000' ]
  },
  
  
  
  
  
  {
    'no': 8,
    'title': '피부나이 측정',
    'desc': '',
    'questions': [
      {
        'askNo': 0,
        'askType': 'single',
        'ask': '식사는 거르지 않고 규칙적으로 한다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': -1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 1 },
        ]
      },
      {
        'askNo': 1,
        'askType': 'single',
        'ask': '하루 3~4시간 이상 햇빛에 노출된다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 3 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': -1 },
        ]
      },
      {
        'askNo': 2,
        'askType': 'single',
        'ask': '외출 할때는 항상 자외선 차단제를 바른다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': -1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 2 },
        ]
      },
      {
        'askNo': 3,
        'askType': 'single',
        'ask': '날마다 화장을 한다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': -1 },
        ]
      },
      {
        'askNo': 4,
        'askType': 'single',
        'ask': '하루에 8시간 이상 잠을 잔다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': -1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 1 },
        ]
      },
      {
        'askNo': 5,
        'askType': 'single',
        'ask': '밤 10시~새벽 2시에는 수면을 취한다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': -2 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 6,
        'askType': 'single',
        'ask': '일주일에 3일 이상 술을 마신다. ',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 2 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': -1 },
        ]
      },
      {
        'askNo': 7,
        'askType': 'single',
        'ask': '담배를 피운다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 2 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': -1 },
        ]
      },
      {
        'askNo': 8,
        'askType': 'single',
        'ask': '일주일에 3일 이상 운동을 한다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': -1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 9,
        'askType': 'single',
        'ask': '물을 수시로 마신다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': -1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 10,
        'askType': 'single',
        'ask': '피곤해서 화장을 지우지 않고 잘 때도 있다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 11,
        'askType': 'single',
        'ask': '내 피부타입에 맞는 세안제를 사용한다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': -1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 12,
        'askType': 'single',
        'ask': '화장하지 않아도 에센스와 영양크림은 챙겨 바른다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': -1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 13,
        'askType': 'single',
        'ask': '안티 에이징 크림이나 비타민 C제품을 바른다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': -2 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 14,
        'askType': 'single',
        'ask': '피부에 문제가 생기면 일단 전문의를 찾는다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': -1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      }
    ],
    'intervention': [
    ],
    'resultType': 'simple',
    'resultTitle': '자신의 나이에 아래 점수를 더해주세요.',
    'results': [],
    'resultMaxPoint': 0,
    'subArcs' : [],
    'colorArray' : []
  },
  
  
  
  
  {
    'no': 9,
    'title': '뇌나이 측정',
    'desc': '',
    'questions': [
      {
        'askNo': 0,
        'askType': 'single',
        'ask': '전화번호나 사람 이름을 자주 잊어버린다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 1,
        'askType': 'single',
        'ask': '어떤 일이 언제 일어났는지 기억하지 못할때가 있다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 2,
        'askType': 'single',
        'ask': '며칠전에 들었던 이야기를 잊어버린다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 3,
        'askType': 'single',
        'ask': '오래전부터 해오던 일은 잘하지만 새로운 것은 배우기 힘들다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 4,
        'askType': 'single',
        'ask': '반복되는 일상생활에 변화가 생겨서 금방 적응하기 힘들다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 5,
        'askType': 'single',
        'ask': '배우자 생일이나 결혼 기념일 등 중요한 사항을 잊어버린다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 6,
        'askType': 'single',
        'ask': '동일한 사람에게 같은 이야기를 반복한다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 7,
        'askType': 'single',
        'ask': '어떤 일을 해놓고도 잊어버린다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 8,
        'askType': 'single',
        'ask': '약속을 해놓고도 잊어버린다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 9,
        'askType': 'single',
        'ask': '이야기하는 도중 무슨 이야기를 하고 있는지 잊어버린다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 10,
        'askType': 'single',
        'ask': '약 먹는 시간을 놓친다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo':11,
        'askType': 'single',
        'ask': '여러가지 물건을 사러 가면 꼭 한 두가지를 빠뜨린다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 12,
        'askType': 'single',
        'ask': '가스 불 끄는 것을 잊어 음식을 태운다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 13,
        'askType': 'single',
        'ask': '같은 질문을 반복한다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 14,
        'askType': 'single',
        'ask': '어떤 일을 해놓고도 했는지 안했는지 몰라 확인한다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 15,
        'askType': 'single',
        'ask': '물건을 두고 다니거나 가지고 갈 물건을 놓고 간다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 16,
        'askType': 'single',
        'ask': '하고 싶은 말, 표현이 금방 떠오르지 않는다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 17,
        'askType': 'single',
        'ask': '물건을 어디에 뒀는지 몰라서 찾는다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 18,
        'askType': 'single',
        'ask': '전에 가본 장소를 기억하지 못한다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 19,
        'askType': 'single',
        'ask': '물건을 항상 두는 장소를 잊어버려 엉뚱한 장소에서 찾는다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      }
    ],
    'intervention': [
    ],
    'resultType': 'gauge',
    'resultTitle': '',
    'results': [
      { 'resultNo': 0, 'resultCondition': '0~5개', 'resultTitle': '[정상] 가끔씩 사소한 것들이 기억 안 날때도 있지만, 지극히 일시적인 기억력 감퇴일뿐 걱정할 필요없음 ', 'resultIconType': 'MoodIcon' },
      { 'resultNo': 1, 'resultCondition': '6~14개', 'resultTitle': '[약간의 건망증] 심한 건망증이 아닐까 고민하는 사람이 대부분 여기에 해당 됨. 지속적으로 스트레스를 받거나 특정 생각에 집착할때, 몸이 지나치게 피곤할 때 발생한다. 지나친 흡연이나 음주, 비타민 결핍등도 일시적으로 기억력을 감퇴시키는 요인이 된다.', 'resultIconType': 'SentimentNeutralIcon' },
      { 'resultNo': 2, 'resultCondition': '15개 이상', 'resultTitle': '[심각한 수준] 전문의와 상담 후 적절한 방법을 찾을 것을 권한다.', 'resultIconType': 'MoodBadIcon' },
    ],
    'resultMaxPoint': 20,
    'subArcs' : [ { limit: 5 }, { limit: 14 }, { limit: 20 } ],
    'colorArray' : [ '#47D9D9', '#FFBB00', '#C80000' ]
  },
  
  
  
  
    {
    'no': 10,
    'title': '혈관나이 측정',
    'desc': '',
    'questions': [
      {
        'askNo': 0,
        'askType': 'single',
        'ask': '흡연',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '안 피운다', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '1년 미만', 'answerPoint': 5 },
          { 'answerNo': 2, 'answerTitle': '5년 미만', 'answerPoint': 10 },
          { 'answerNo': 3, 'answerTitle': '5~10년', 'answerPoint': 15 },
          { 'answerNo': 4, 'answerTitle': '10년 이상', 'answerPoint': 20 }
        ]
      },
      {
        'askNo': 1,
        'askType': 'single',
        'ask': '콜레스테롤',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '200mg/dl 이하', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '200~240mg/dl', 'answerPoint': 10 },
          { 'answerNo': 2, 'answerTitle': '240mg/dl 이상', 'answerPoint': 15 }
        ]
      },
      {
        'askNo': 2,
        'askType': 'single',
        'ask': '비만',
        'answer': [
          { 'answerNo': 0, 'answerTitle': 'BMI 23 이하', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': 'BMI 23~27', 'answerPoint': 5 },
          { 'answerNo': 2, 'answerTitle': 'BMI 27 이상', 'answerPoint': 10 }
        ]
      },
      {
        'askNo': 3,
        'askType': 'single',
        'ask': '혈압',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '130/85mmHg 이하', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '140/95~160/100mmHg', 'answerPoint': 10 },
          { 'answerNo': 2, 'answerTitle': '160/100mmHg 이상', 'answerPoint': 15 }
        ]
      },
      {
        'askNo': 4,
        'askType': 'single',
        'ask': '식습관(육류 및 피자 등 기름진 음식을 먹는 횟수)',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '한달에 한 두번', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '일주일에 3번', 'answerPoint': 3 },
          { 'answerNo': 2, 'answerTitle': '거의 매일', 'answerPoint': 5 }
        ]
      },
      {
        'askNo': 5,
        'askType': 'single',
        'ask': '음주 (일주일 단위)',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '3회 이상', 'answerPoint': 5 },
          { 'answerNo': 1, 'answerTitle': '3회 미만', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 6,
        'askType': 'single',
        'ask': '스트레스',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '별로 받지 않는다', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '자주 받는다', 'answerPoint': 5 },
        ]
      },
      {
        'askNo': 7,
        'askType': 'single',
        'ask': '운동',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '3회 이상 꾸준히', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '3회 미만', 'answerPoint': 5 },
        ]
      },
      {
        'askNo': 8,
        'askType': 'single',
        'ask': '나이',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '45세 이전', 'answerPoint': 10 },
          { 'answerNo': 1, 'answerTitle': '45세 이상', 'answerPoint': 20 },
        ]
      },
      {
        'askNo': 9,
        'askType': 'single',
        'ask': '가족력',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '없다', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '있다', 'answerPoint': 5 },
        ]
      }
    ],
    'intervention': [
    ],
    'resultType': 'gauge',
    'resultTitle': '',
    'results': [
      { 'resultNo': 0, 'resultCondition': '30점 이하', 'resultTitle': '[28세] 젊은 혈관 유지 노력 필요', 'resultIconType': 'MoodIcon' },
      { 'resultNo': 1, 'resultCondition': '30~59점', 'resultTitle': '[35세] 방심은 금물. 혈관 노화 예방에 노력 필요', 'resultIconType': 'SentimentNeutralIcon' },
      { 'resultNo': 2, 'resultCondition': '60~79점', 'resultTitle': '[45세] 성인병 발병 위험 노출, 건강 진단 필요', 'resultIconType': 'SentimentVeryDissatisfiedIcon' },
      { 'resultNo': 3, 'resultCondition': '80점 이상', 'resultTitle': '[55세] 혈관 노화 심각. 전문의 진단 필요', 'resultIconType': 'MoodBadIcon' },
    ],
    'resultMaxPoint': 105,
    'subArcs' : [ { limit: 30 }, { limit: 59 }, { limit: 79 }, { limit: 105 } ],
    'colorArray' : [ '#47D9D9', '#FFBB00', '#FF8000', '#C80000' ]
  },
  
  
  
  
  {
    'no': 11,
    'title': '남성 비교기과 진료',
    'desc': '이 설문에서 \'성행위\'란 성교 자체, 애무, 전희, 자위 행위를 모두 포함합니다. 성교라 함은 파트너의 성기와 결합한 상태에서 행하는 일체의 행동을 의미하며, \'성적 자극\'이란 파트너와의 전희 또는 에로틱한 영화, 그림, 비디오의 관람을 포함합니다.',
    'questions': [
      {
        'askNo': 0,
        'askType': 'single',
        'ask': '지난 4주 동안, 성 행위 시 몇 번이나 발기가 가능하였습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '거의 한번도 없었다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '가끔씩(총 횟수의 50% 훨씬 못 미침)', 'answerPoint': 2 },
          { 'answerNo': 2, 'answerTitle': '때때로(총 횟수의 50%)', 'answerPoint': 3 },
          { 'answerNo': 3, 'answerTitle': '대부분(총 횟수의 50% 훨씬 넘음)', 'answerPoint': 4 },
          { 'answerNo': 4, 'answerTitle': '항상 또는 거의 항상', 'answerPoint': 5 }
        ]
      },
      {
        'askNo': 1,
        'askType': 'single',
        'ask': '지난 4주 동안, 성적 자극으로 발기되었을 때, 성교가 가능한 발기는 몇 번이나 있었습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '거의 한번도 없었다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '가끔씩(총 횟수의 50% 훨씬 못 미침)', 'answerPoint': 2 },
          { 'answerNo': 2, 'answerTitle': '때때로(총 횟수의 50%)', 'answerPoint': 3 },
          { 'answerNo': 3, 'answerTitle': '대부분(총 횟수의 50% 훨씬 넘음)', 'answerPoint': 4 },
          { 'answerNo': 4, 'answerTitle': '항상 또는 거의 항상', 'answerPoint': 5 }
        ]
      },
      {
        'askNo': 2,
        'askType': 'single',
        'ask': '지난 4주 동안, 성교를 시도할 때, 몇 번이나 파트너의 질 내로 삽입할 수 있었습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '거의 한번도 없었다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '가끔씩(총 횟수의 50% 훨씬 못 미침)', 'answerPoint': 2 },
          { 'answerNo': 2, 'answerTitle': '때때로(총 횟수의 50%)', 'answerPoint': 3 },
          { 'answerNo': 3, 'answerTitle': '대부분(총 횟수의 50% 훨씬 넘음)', 'answerPoint': 4 },
          { 'answerNo': 4, 'answerTitle': '항상 또는 거의 항상', 'answerPoint': 5 }
        ]
      },
      {
        'askNo': 3,
        'askType': 'single',
        'ask': '지난 4주 동안, 성교하는 중에 발기 상태가 끝까지 유지된 적이 몇 번이나 있었습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '거의 한번도 없었다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '가끔씩(총 횟수의 50% 훨씬 못 미침)', 'answerPoint': 2 },
          { 'answerNo': 2, 'answerTitle': '때때로(총 횟수의 50%)', 'answerPoint': 3 },
          { 'answerNo': 3, 'answerTitle': '대부분(총 횟수의 50% 훨씬 넘음)', 'answerPoint': 4 },
          { 'answerNo': 4, 'answerTitle': '항상 또는 거의 항상', 'answerPoint': 5 }
        ]
      },
      {
        'askNo': 4,
        'askType': 'single',
        'ask': '지난 4주 동안, 성교 시 성교를 끝마칠 때까지 발기 상태를 유지하는 것이 얼마나 어려웠습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '지극히 어려웠다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '매우 어려웠다', 'answerPoint': 2 },
          { 'answerNo': 2, 'answerTitle': '어려웠다', 'answerPoint': 3 },
          { 'answerNo': 3, 'answerTitle': '약간 어려웠다', 'answerPoint': 4 },
          { 'answerNo': 4, 'answerTitle': '전혀 어렵지 않았다', 'answerPoint': 5 }
        ]
      }
    ],
    'intervention': [
    ],
    'resultType': 'gauge',
    'resultTitle': '',
    'results': [
      { 'resultNo': 0, 'resultCondition': '5~7점', 'resultTitle': '중증', 'resultIconType': 'MoodBadIcon' },
      { 'resultNo': 1, 'resultCondition': '8~11점', 'resultTitle': '중증도', 'resultIconType': 'SentimentVeryDissatisfiedIcon' },
      { 'resultNo': 2, 'resultCondition': '12~16점', 'resultTitle': '경증~중증도', 'resultIconType': 'SentimentNeutralIcon' },
      { 'resultNo': 3, 'resultCondition': '17~21점', 'resultTitle': '경증', 'resultIconType': 'SentimentSatisfiedAltIcon' },
      { 'resultNo': 4, 'resultCondition': '22점 이상', 'resultTitle': '정상', 'resultIconType': 'MoodIcon' },
    ],
    'resultMaxPoint': 25,
    'subArcs' : [ { limit: 7 }, { limit: 11 }, { limit: 16 }, { limit: 21 }, { limit: 25 } ],
    'colorArray' : [ '#C80000', '#FF8000', '#FFBB00', '#8AB904', '#47D9D9' ]
  },
  
  
  
  
  {
    'no': 12,
    'title': '신체 불균형 자가 진단',
    'desc': '',
    'questions': [
      {
        'askNo': 0,
        'askType': 'single',
        'ask': '바지 길이나 소매 길이 양쪽에 차이가 있다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 1,
        'askType': 'single',
        'ask': '가방을 매면 한쪽으로 자꾸 흘러내린다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 2,
        'askType': 'single',
        'ask': '치마나 바지가 한쪽으로 돌아간다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 3,
        'askType': 'single',
        'ask': '다리를 꼬고 앉을 때 더 편한 쪽이 있다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 4,
        'askType': 'single',
        'ask': '한쪽 신발 밑창이 더 많이 닳아 있다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 5,
        'askType': 'single',
        'ask': '배를 내밀고 서 있는 편이다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 6,
        'askType': 'single',
        'ask': '뒷목이 늘 뻐근하다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 7,
        'askType': 'single',
        'ask': '편두통이 자주 온다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 8,
        'askType': 'single',
        'ask': '뒤돌아 보는 동작이 괴롭다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 9,
        'askType': 'single',
        'ask': '자세가 구부정하고 실제 키보다 작아 보인다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 10,
        'askType': 'single',
        'ask': '한쪽 다리가 자주 저리고 당긴다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 11,
        'askType': 'single',
        'ask': '서 있는 것보다 앉아 있을 때 허리 통증이 더 심해진다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 12,
        'askType': 'single',
        'ask': '걸음걸이가 특이하다는 말을 자주 듣는다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 13,
        'askType': 'single',
        'ask': '발목을 자주 삐끗한다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      }
    ],
    'intervention': [],
    'resultType': 'simple',
    'resultTitle': '위 사항 중 3개 이상이면 검사와 상담이 필요하다.',
    'results': [],
    'resultMaxPoint': 0,
    'subArcs' : [],
    'colorArray' : []
  },
  
  
  
  
  {
    'no': 13,
    'title': 'PTSD',
    'desc': '다음은 심한 스트레스(트라우마)를 경험한 사람들에게 발생할 수 있는 문제들입니다. 각 문 항을 주의 깊게 읽고, 재난 이후 지금까지 또는 지난 한 달 동안(혹은 더 짧은 기간), 다음과 같은 문제로 얼마나 고통스러웠는지를 답해 주십시오.',
    'questions': [
      {
        'askNo': 0,
        'askType': 'single',
        'ask': '그 스트레스 경험에 대한 불쾌하고 기억하고 싶지 않은 기억이 반복적으로 떠오릅니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '전혀 아님', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '약', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '보통', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '많이', 'answerPoint': 3 },
          { 'answerNo': 4, 'answerTitle': '매우 많이', 'answerPoint': 4 }
        ]
      },
      {
        'askNo': 1,
        'askType': 'single',
        'ask': '그 스트레스 경험에 대한 악몽을 반복해서 꾸십니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '전혀 아님', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '약', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '보통', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '많이', 'answerPoint': 3 },
          { 'answerNo': 4, 'answerTitle': '매우 많이', 'answerPoint': 4 }
        ]
      },
      {
        'askNo': 2,
        'askType': 'single',
        'ask': '별안간 그 스트레스 경험을 실제로 다시 겪는 것처럼 (마치 그 곳에 실제로 되돌아가서 경험하는 것 같이) 느껴지거나 행동하게 됩니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '전혀 아님', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '약', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '보통', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '많이', 'answerPoint': 3 },
          { 'answerNo': 4, 'answerTitle': '매우 많이', 'answerPoint': 4 }
        ]
      },
      {
        'askNo': 3,
        'askType': 'single',
        'ask': '뭔가 그 스트레스 경험을 다시 떠오르게 한다면, 매우 불쾌한 감정을 느끼십니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '전혀 아님', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '약', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '보통', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '많이', 'answerPoint': 3 },
          { 'answerNo': 4, 'answerTitle': '매우 많이', 'answerPoint': 4 }
        ]
      },
      {
        'askNo': 4,
        'askType': 'single',
        'ask': '뭔가 그 스트레스 경험을 다시 떠오르게 한다면, 격한 신체반응이 나타납니까? (예를 들면, 심장이 두근거리거나, 숨쉬기 힘들거나, 땀이 나는 것)',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '전혀 아님', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '약', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '보통', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '많이', 'answerPoint': 3 },
          { 'answerNo': 4, 'answerTitle': '매우 많이', 'answerPoint': 4 }
        ]
      },
      {
        'askNo': 5,
        'askType': 'single',
        'ask': '그 스트레스 경험과 관련된 기억이나 생각 또는 감정을 피하십니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '전혀 아님', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '약', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '보통', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '많이', 'answerPoint': 3 },
          { 'answerNo': 4, 'answerTitle': '매우 많이', 'answerPoint': 4 }
        ]
      },
      {
        'askNo': 6,
        'askType': 'single',
        'ask': '그 스트레스 경험을 떠오르게 하는 외부 상황을 피하십니까? (예를 들면, 사람, 장소, 대화, 활동, 물건 또는 상황)',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '전혀 아님', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '약', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '보통', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '많이', 'answerPoint': 3 },
          { 'answerNo': 4, 'answerTitle': '매우 많이', 'answerPoint': 4 }
        ]
      },
      {
        'askNo': 7,
        'askType': 'single',
        'ask': '그 스트레스 경험의 중요한 부분을 기억하기 어렵습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '전혀 아님', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '약', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '보통', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '많이', 'answerPoint': 3 },
          { 'answerNo': 4, 'answerTitle': '매우 많이', 'answerPoint': 4 }
        ]
      },
      {
        'askNo': 8,
        'askType': 'single',
        'ask': '자기 자신, 다른 사람들, 혹은 세상에 대해 매우 부정적인 신념을 가지고 있습니까? (예를 들면, 나는 나쁘다, 나에게는 뭔가 심각하게 잘못된 것이 있다, 아무도 믿을 수 없다, 세상은 너무나 위험하다)?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '전혀 아님', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '약', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '보통', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '많이', 'answerPoint': 3 },
          { 'answerNo': 4, 'answerTitle': '매우 많이', 'answerPoint': 4 }
        ]
      },
      {
        'askNo': 9,
        'askType': 'single',
        'ask': '그 스트레스 경험이나 그 경험 이후에 일어난 일들에 대하여 자기 자신 탓이나 다른 사람 탓을 하고 있습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '전혀 아님', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '약', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '보통', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '많이', 'answerPoint': 3 },
          { 'answerNo': 4, 'answerTitle': '매우 많이', 'answerPoint': 4 }
        ]
      },
      {
        'askNo': 10,
        'askType': 'single',
        'ask': '공포, 혐오, 분노, 죄책감, 수치심 같은 매우 부정적인 감정이 있습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '전혀 아님', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '약', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '보통', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '많이', 'answerPoint': 3 },
          { 'answerNo': 4, 'answerTitle': '매우 많이', 'answerPoint': 4 }
        ]
      },
      {
        'askNo': 11,
        'askType': 'single',
        'ask': '이전에 자주 즐겼던 활동들에 대한 흥미를 잃어버렸습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '전혀 아님', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '약', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '보통', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '많이', 'answerPoint': 3 },
          { 'answerNo': 4, 'answerTitle': '매우 많이', 'answerPoint': 4 }
        ]
      },
      {
        'askNo': 12,
        'askType': 'single',
        'ask': '다른 사람들과 동떨어졌거나 단절되었다고 느끼십니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '전혀 아님', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '약', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '보통', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '많이', 'answerPoint': 3 },
          { 'answerNo': 4, 'answerTitle': '매우 많이', 'answerPoint': 4 }
        ]
      },
      {
        'askNo': 13,
        'askType': 'single',
        'ask': '긍정적인 감정을 느끼는 것이 어렵습니까? (예를 들면, 행복 하다고 느낄 수 없거나 가까운 사람들에 대해 사랑하는 감정을 가질 수 없음)',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '전혀 아님', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '약', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '보통', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '많이', 'answerPoint': 3 },
          { 'answerNo': 4, 'answerTitle': '매우 많이', 'answerPoint': 4 }
        ]
      },
      {
        'askNo': 14,
        'askType': 'single',
        'ask': '과민 행동, 분노 폭발 또는 공격적인 행동을 하십니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '전혀 아님', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '약', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '보통', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '많이', 'answerPoint': 3 },
          { 'answerNo': 4, 'answerTitle': '매우 많이', 'answerPoint': 4 }
        ]
      },
      {
        'askNo': 15,
        'askType': 'single',
        'ask': '너무 많은 위험을 감수하거나 자신에게 해가 될 수 있는 위험한 행동을 하십니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '전혀 아님', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '약', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '보통', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '많이', 'answerPoint': 3 },
          { 'answerNo': 4, 'answerTitle': '매우 많이', 'answerPoint': 4 }
        ]
      },
      {
        'askNo': 16,
        'askType': 'single',
        'ask': '조금도 방심하지 않으려고 하거나 주변을 감시하거나 혹은 경계하게 되십니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '전혀 아님', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '약', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '보통', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '많이', 'answerPoint': 3 },
          { 'answerNo': 4, 'answerTitle': '매우 많이', 'answerPoint': 4 }
        ]
      },
      {
        'askNo': 17,
        'askType': 'single',
        'ask': '조마조마한 느낌이 들거나 쉽게 깜짝 놀라십니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '전혀 아님', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '약', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '보통', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '많이', 'answerPoint': 3 },
          { 'answerNo': 4, 'answerTitle': '매우 많이', 'answerPoint': 4 }
        ]
      },
      {
        'askNo': 18,
        'askType': 'single',
        'ask': '집중하기가 어렵습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '전혀 아님', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '약', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '보통', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '많이', 'answerPoint': 3 },
          { 'answerNo': 4, 'answerTitle': '매우 많이', 'answerPoint': 4 }
        ]
      },
      {
        'askNo': 19,
        'askType': 'single',
        'ask': '잠들기가 어렵거나 중간에 깨십니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '전혀 아님', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '약', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '보통', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '많이', 'answerPoint': 3 },
          { 'answerNo': 4, 'answerTitle': '매우 많이', 'answerPoint': 4 }
        ]
      }
    ],
    'intervention': [
    ],
    'resultType': 'gauge',
    'resultTitle': '',
    'results': [
      { 'resultNo': 0, 'resultCondition': '총점 37점 이하', 'resultTitle': 'PTSD 의심되지 않음', 'resultIconType': 'MoodIcon' },
      { 'resultNo': 1, 'resultCondition': '총점 38점 이상', 'resultTitle': 'PTSD 의심', 'resultIconType': 'MoodBadIcon' },
    ],
    'resultMaxPoint': 80,
    'subArcs' : [ { limit: 37 }, { limit: 80 } ],
    'colorArray' : [ '#47D9D9', '#C80000' ]
  },
  
  
  
  
  {
    'no': 14,
    'title': '남성갱년기',
    'desc': '',
    'questions': [
      {
        'askNo': 0,
        'askType': 'single',
        'ask': '성적 흥미가 감소했습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 1,
        'askType': 'single',
        'ask': '기력이 몹시 떨어졌습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 2,
        'askType': 'single',
        'ask': '근력 및 지구력이 떨어졌습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 3,
        'askType': 'single',
        'ask': '키가 다소 줄었습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 4,
        'askType': 'single',
        'ask': '삶의 즐거움을 잃었습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 5,
        'askType': 'single',
        'ask': '슬프거나 불안감이 많이 납니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 6,
        'askType': 'single',
        'ask': '발기력이 감소했습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 7,
        'askType': 'single',
        'ask': '운동할 때 민첩성이 떨어졌습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 8,
        'askType': 'single',
        'ask': '저녁 식사 후 졸음이 잦습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 9,
        'askType': 'single',
        'ask': '업무능력이 떨어졌습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      }
    ],
    'intervention': [],
    'resultType': 'simple',
    'resultTitle': '설문지 문항 중 1번 또는 7번 항목에 해당되거나 그 외에 다른 3개 항목이 동시에 해당될 경우 남성 갱년기를 의심한다.',
    'results': [],
    'resultMaxPoint': 0,
    'subArcs' : [],
    'colorArray' : []
  },
  
  
  
  
    {
    'no': 15,
    'title': '여성갱년기',
    'desc': '',
    'questions': [
      {
        'askNo': 0,
        'askType': 'single',
        'ask': '35세 이상이다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 1,
        'askType': 'single',
        'ask': '갑작스러운 안면 홍조와 지나치게 많이 나오는 땀 때문에 괴롭다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 2,
        'askType': 'single',
        'ask': '표현하기 힘든 감정적 변화(불안, 짜증, 슬픔 등)에 시달리고 있다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 3,
        'askType': 'single',
        'ask': '유방이 평소보다 더 부드럽고 민감하다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 4,
        'askType': 'single',
        'ask': '질이 건조하고 성교 시 통증이 있다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 5,
        'askType': 'single',
        'ask': '성욕이 줄어 들었다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 6,
        'askType': 'single',
        'ask': '얼굴 피부가 변했다.(피부가 건조해지고 없던 털이나 여드름이 생기는 등)',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 7,
        'askType': 'single',
        'ask': '평소보다 피로를 자주 느끼고 수면 장애가 있다. ',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 8,
        'askType': 'single',
        'ask': '생리주기와 양이 불규칙해졌다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      },
      {
        'askNo': 9,
        'askType': 'single',
        'ask': '집중력, 기억력이 떨어졌다.',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 0 },
        ]
      }
    ],
    'intervention': [
    ],
    'resultType': 'gauge',
    'resultTitle': '',
    'results': [
      { 'resultNo': 0, 'resultCondition': '3개 이하', 'resultTitle': '갱년기 증상이 거의 없습니다. 아직 증상이 나타나지는 않았지만 갱년기로 접어들었을 수도 있으니 식사요법, 운동요법을 통해 대비한다.', 'resultIconType': 'MoodIcon' },
      { 'resultNo': 1, 'resultCondition': '4개 이상', 'resultTitle': '갱년기 증상이 있습니다. 증상완화를 위해 여러가지 방법들을 적극적으로 실천하며 갱년기를 지혜롭게 보낸다.', 'resultIconType': 'MoodBadIcon' },
    ],
    'resultMaxPoint': 10,
    'subArcs' : [ { limit: 3 }, { limit: 10 } ],
    'colorArray' : [ '#47D9D9', '#C80000' ]
  },
  
  
  
  
  
];